import { render, staticRenderFns } from "./ComplainceAssessmentReport.vue?vue&type=template&id=0bfb72c7&scoped=true"
import script from "./ComplainceAssessmentReport.vue?vue&type=script&lang=js"
export * from "./ComplainceAssessmentReport.vue?vue&type=script&lang=js"
import style0 from "./ComplainceAssessmentReport.vue?vue&type=style&index=0&id=0bfb72c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb72c7",
  null
  
)

export default component.exports